/*
 * Wraps SATComponent.prototype.renderVals to surface real carrier tracking
 * on a successful "Track An Order" lookup (see snippets/sat-overlays.liquid,
 * the trackFound panel). trackOrder() in sat-app.js already does the real
 * work — matching the typed SAT number against a real Shopify order and
 * mapping its real fulfillment_status onto the five-step tracker — this
 * patch only adds the piece that was still missing: an actual "track this
 * with the carrier" link, straight from Shopify's own fulfillment record
 * (see snippets/sat-bootstrap.liquid, which now carries trackingNumber /
 * trackingUrl / trackingCompany on every order), instead of the five-step
 * bar being the only thing a shopper gets. No fulfillment yet just means
 * these stay blank, exactly like every other pre-fulfillment order today.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var s = this.state;

    var result = s.trackResult;
    if (result && !result.error) {
      var order = this.readOrders().find(function (o) {
        return String(o.no).toUpperCase() === String(result.no).toUpperCase();
      });
      var trackingNumber = (order && order.trackingNumber) || '';
      var trackingUrl = (order && order.trackingUrl) || '';
      var trackingCompany = (order && order.trackingCompany) || '';
      out.trackHasCarrier = !!(trackingNumber || trackingUrl);
      out.trackResultCarrier = trackingCompany || 'Carrier';
      out.trackResultTrackingNumber = trackingNumber;
      out.trackResultTrackingUrl = trackingUrl || null;
    } else {
      out.trackHasCarrier = false;
      out.trackResultCarrier = '';
      out.trackResultTrackingNumber = '';
      out.trackResultTrackingUrl = null;
    }

    return out;
  };
})();
